import { Result, theme } from 'antd'
import React from 'react'
import { ReactComponent as EmptyBox } from '../../assets/empty-state.svg'
import { ReactComponent as EmptySearch } from '../../assets/empty-search.svg'
import { ReactComponent as EmptyPlane } from '../../assets/empty-plane.svg'
import { ReactComponent as EmptyDashboard } from '../../assets/empty-dashboard.svg'
import { ReactComponent as EmptyReport } from '../../assets/empty-report.svg'
import { ReactComponent as EmptyReportSections } from '../../assets/empty-report-sections.svg'
import { ReactComponent as EmptySelectCompany } from '../../assets/empty-select-company.svg'

const illustrations = {
  empty: EmptyBox,
  search: EmptySearch,
  plane: EmptyPlane,
  dashboard: EmptyDashboard,
  report: EmptyReport,
  reportSections: EmptyReportSections,
  selectCompany: EmptySelectCompany
}

interface EmptyStateProps {
  /** Illustration shown above the title; `icon` replaces it. Defaults to the empty box. */
  illustration?: keyof typeof illustrations
  icon?: React.ReactNode
  title: React.ReactNode
  /** Primary way out of the empty state, e.g. an "Add new" button. */
  action?: React.ReactNode
}

/** Placeholder for a page or section that has loaded but has no data yet. */
const EmptyState: React.FC<EmptyStateProps> = ({ illustration = 'empty', icon, title, action }) => {
  const { token } = theme.useToken()
  const Illustration = illustrations[illustration]

  // The illustrations read their colors from CSS variables, mapped here to the theme
  const illustrationColors = {
    '--empty-accent': token.colorPrimary,
    '--empty-muted': token.colorPrimaryBg,
    '--empty-surface': token.colorBgContainer,
    '--empty-line': token.colorPrimaryBorder
  } as React.CSSProperties

  return (
    <Result
      icon={icon ?? <Illustration style={{ ...illustrationColors, maxWidth: '100%', height: 'auto' }} />}
      title={title}
      extra={action}
    />
  )
}

export default EmptyState
